export default {
  path: '/index',
  name: 'index',
  redirect: {
    name: 'memberCenter'
  },
  component: function component() {
    return import('@/layouts/basic-layout');
  },
  children: [// 店铺管理-页面管理-列表页
  {
    path: 'pageManageList',
    name: 'pageManageList',
    meta: {
      title: '页面管理',
      menuTab: '',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['pageManageList']
    },
    component: function component() {
      return import('@/pages/storeModule/storeDecorationMenu/pageManageList/pageManageList');
    }
  }, // 店铺管理-页面管理-店铺编辑
  {
    path: 'editorPage',
    name: 'editorPage',
    meta: {
      title: '店铺编辑',
      hidden: true
    },
    component: function component() {
      return import('@/pages/storeModule/storeDecorationMenu/pageManageList/editorPage');
    }
  }, // 店铺管理-模板管理-列表页
  {
    path: 'templateManageList',
    name: 'templateManageList',
    meta: {
      title: '模板管理',
      menuTab: '',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['templateManageList']
    },
    component: function component() {
      return import('@/pages/storeModule/storeDecorationMenu/templateManageList/templateManageList');
    }
  }, // 店铺管理页面
  // {
  //   path: 'storDecorateManage',
  //   name: 'storDecorateManage',
  //   meta: {
  //     title: '店铺装修',
  //     menuTab: '',
  //     cache: true
  //   },
  //   component: () => import('@/pages/storeModule/storeDecorationMenu/storDecorateManage/storDecorateManage')
  // },
  // 店铺管理-模板管理-关于我们样式1
  {
    path: 'aboutUsFirstPage',
    name: 'aboutUsFirstPage',
    meta: {
      title: '关于我们样式1',
      hidden: true
    },
    component: function component() {
      return import('@/pages/storeModule/storeDecorationMenu/templateManageList/aboutUsFirstPage');
    }
  }, // 店铺管理-模板管理-关于我们样式2
  {
    path: 'aboutUsSecondPage',
    name: 'aboutUsSecondPage',
    meta: {
      title: '关于我们样式2',
      hidden: true
    },
    component: function component() {
      return import('@/pages/storeModule/storeDecorationMenu/templateManageList/aboutUsSecondPage');
    }
  }, // 店铺管理-模板管理-首页样式1
  {
    path: 'homeFirstPage',
    name: 'homeFirstPage',
    meta: {
      title: '首页样式1',
      hidden: true
    },
    component: function component() {
      return import('@/pages/storeModule/storeDecorationMenu/templateManageList/homeFirstPage');
    }
  }, // 店铺管理-模板管理-首页样式2
  {
    path: 'homeSecondPage',
    name: 'homeSecondPage',
    meta: {
      title: '首页样式2',
      hidden: true
    },
    component: function component() {
      return import('@/pages/storeModule/storeDecorationMenu/templateManageList/homeSecondPage');
    }
  }, // 店铺管理-模板管理-首页样式2-新
  {
    path: 'newHomeSecondPage',
    name: 'newHomeSecondPage',
    meta: {
      title: '首页样式2',
      hidden: true
    },
    component: function component() {
      return import('@/pages/storeModule/storeDecorationMenu/templateManageList/newHomeSecondPage');
    }
  }, // 店铺管理-页面管理-店铺预览
  {
    path: 'storePreviewPage',
    name: 'storePreviewPage',
    meta: {
      title: '店铺预览',
      hidden: true
    },
    component: function component() {
      return import('@/pages/storeModule/storeDecorationMenu/pageManageList/storePreviewPage');
    }
  }, // 店铺管理（供应商侧）-创建店铺-店铺申请
  {
    path: 'createStoreIndex',
    name: 'createStoreIndex',
    meta: {
      title: '店铺申请',
      menuTab: '',
      cache: false,
      isCheckMenu: true,
      belongMenus: ['createStoreIndex']
    },
    component: function component() {
      return import('@/pages/storeModule/storeManageMenu/createStore/createStoreIndex.vue');
    }
  }, // 店铺管理（供应商侧）-创建店铺-信息录入
  {
    path: 'createStoreAdd',
    name: 'createStoreAdd',
    meta: {
      title: '店铺创建',
      menuTab: '',
      cache: false,
      hidden: true
    },
    component: function component() {
      return import('@/pages/storeModule/storeManageMenu/createStore/createStoreAdd.vue');
    }
  }, // 店铺管理（供应商侧）-创建店铺-店铺修改
  {
    path: 'createStoreEdit',
    name: 'createStoreEdit',
    meta: {
      title: '店铺修改',
      menuTab: '',
      cache: false
    },
    component: function component() {
      return import('@/pages/storeModule/storeManageMenu/createStore/createStoreEdit.vue');
    }
  }, // 店铺管理（供应商侧）-创建店铺-店铺变更
  {
    path: 'createStoreUpdate',
    name: 'createStoreUpdate',
    meta: {
      title: '店铺变更',
      menuTab: '',
      cache: false
    },
    component: function component() {
      return import('@/pages/storeModule/storeManageMenu/createStore/createStoreUpdate.vue');
    }
  }, // 店铺管理（供应商侧）-创建店铺-店铺预览
  {
    path: 'createStorePreview',
    name: 'createStorePreview',
    meta: {
      title: '店铺预览',
      menuTab: '',
      cache: false
    },
    component: function component() {
      return import('@/pages/storeModule/storeManageMenu/createStore/createStorePreview.vue');
    }
  }, // 店铺管理（供应商侧）-创建店铺-页面管理(新)
  {
    path: 'newPageManageList',
    name: 'newPageManageList',
    meta: {
      title: '页面管理',
      menuTab: '',
      cache: false
    },
    component: function component() {
      return import('@/pages/storeModule/storeDecorationMenu/pageManageList/newPageManageList.vue');
    }
  }, // 店铺管理（供应商侧）-创建店铺-页面管理(新)
  {
    path: 'newHomeFirstPage',
    name: 'newHomeFirstPage',
    meta: {
      title: '首页样式一',
      hidden: true
    },
    component: function component() {
      return import('@/pages/storeModule/storeDecorationMenu/templateManageList/newHomeFirstPage.vue');
    }
  }, // 店铺管理（供应商侧）-创建店铺-页面管理(新)
  {
    path: 'newFirstComanyPage',
    name: 'newFirstComanyPage',
    meta: {
      title: '公司简介',
      hidden: true
    },
    component: function component() {
      return import('@/pages/storeModule/storeDecorationMenu/templateManageList/newFirstComanyPage.vue');
    }
  }, // 店铺管理（供应商侧）-创建店铺-页面管理(新)
  {
    path: 'newFirstContactUs',
    name: 'newFirstContactUs',
    meta: {
      title: '联系我们',
      hidden: true
    },
    component: function component() {
      return import('@/pages/storeModule/storeDecorationMenu/templateManageList/newFirstContactUs.vue');
    }
  }, // 店铺管理（供应商侧）-店铺修改
  {
    path: 'storeManaEdit',
    name: 'storeManaEdit',
    meta: {
      title: '修改店铺信息',
      hidden: true
    },
    component: function component() {
      return import('@/pages/storeModule/storeManageMenu/createStore/storeManaEdit.vue');
    }
  }]
};